import { render } from "./UsersListStatusItem.vue?vue&type=template&id=152fecac&scoped=true&ts=true"
import script from "./UsersListStatusItem.vue?vue&type=script&lang=ts"
export * from "./UsersListStatusItem.vue?vue&type=script&lang=ts"

import "./UsersListStatusItem.vue?vue&type=style&index=0&id=152fecac&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152fecac"]])

export default __exports__